export default __webpack_public_path__ + "static/media/undraw-experience-about-page.78b3d064.svg";